import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";

function* getStateLicenses() {
  const { success, data, error } = yield* makeRequest.get("/state_licenses", {});

  if (success && data) {
    yield put(actions.setStateLicenses(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: "There was an error getting career listings",
    });
  }

  return null;
}

export default getStateLicenses;
